"use strict";
exports.__esModule = true;
var QueueLink_1 = require("./QueueLink");
exports["default"] = QueueLink_1["default"];
//# sourceMappingURL=index.js.map